<div class="pagination-bar pt-1 pb-1 ps-2 pe-2  border-top d-flex justify-content-between align-items-center">
  <div class="pagination-info fw-bold">
    Showing {{ actualTotalItems > 0 ? (currentPage * pageSize) + 1 : 0 }} to {{ minLimit }} of {{ actualTotalItems }} {{
    itemName }}
  </div>

  <div class="pagination-actions d-flex align-items-center gap-3">
    <!-- Items per page dropdown -->
    <div class="select-wrapper position-relative d-flex align-items-center">
      <mat-select class="page-size-dropdown w-100 m-0" [value]="pageSize"
        panelClass="page-size-select-panel" aria-label="Items per page"
        (selectionChange)="onPageSizeChange($event.value)">
        @for (size of pageSizeOptions; track size) {
        <mat-option [value]="size">{{ size }} per page</mat-option>
        }
      </mat-select>
    </div>

    <!-- Pagination controls -->
    <div class="pagination-controls d-flex gap-2 align-items-center">
      <button class="pagination-btn outline-btn d-flex align-items-center justify-content-center"
        [disabled]="currentPage === 0" (click)="changePage(currentPage - 1)">
        <span class="material-icons pagination-icon">keyboard_arrow_left</span>
      </button>

      @for (page of getPages(); track page) {
      <button class="pagination-btn outline-btn d-flex align-items-center justify-content-center"
        [ngClass]="{'active': page === currentPage + 1}" (click)="onPageButtonClick(page)" [disabled]="page === '...'">
        {{ page }}
      </button>
      }

      <button class="pagination-btn outline-btn d-flex align-items-center justify-content-center"
        [disabled]="currentPage >= totalPages - 1" (click)="changePage(currentPage + 1)">
        <span class="material-icons pagination-icon">keyboard_arrow_right</span>
      </button>
    </div>
  </div>

  <!-- Export button + menu -->
  @if (showExport) {
  <div class="export-wrapper">
    <button class="export-btn" (click)="toggleExportMenu()">
      <span class="material-icons">upload_file</span>
      <span class="material-icons chevron">
        {{ exportMenuOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
      </span>
    </button>
    @if (exportMenuOpen) {
    <div class="export-menu">
      <p class="export-title">Select Report Format</p>
      <mat-radio-group class="export-radio-group" [(ngModel)]="selectedExport"
        (change)="onExportFormatChange(selectedExport)">
        <mat-radio-button class="export-option" value="csv">CSV</mat-radio-button>
        <mat-radio-button class="export-option" value="xls">XLS</mat-radio-button>
        <mat-radio-button class="export-option" value="pdf">PDF</mat-radio-button>
      </mat-radio-group>
      <button class="export-confirm-btn" (click)="confirmExport()">
        Export
      </button>
    </div>
    }
  </div>
  }


</div>
